import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, authToken } from "@/lib/api";

export const RequireAdmin = ({ children }) => {
  const nav = useNavigate();
  const [ok, setOk] = useState(null);
  useEffect(() => {
    api.get("/auth/me")
      .then(() => setOk(true))
      .catch(() => { authToken.clear(); setOk(false); nav("/admin/login"); });
  }, [nav]);
  if (ok === null)
    return (
      <div className="flex min-h-screen items-center justify-center text-taupe">
        <Loader2 className="animate-spin" />
      </div>
    );
  if (!ok) return null;
  return children;
};
